export default "__VITE_ASSET__CqANNp9g__"